import { render, staticRenderFns } from "./FamilyActivityEmailTable.vue?vue&type=template&id=0ccdb3b0&scoped=true&"
import script from "./FamilyActivityEmailTable.vue?vue&type=script&lang=ts&"
export * from "./FamilyActivityEmailTable.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyActivityEmailTable.vue?vue&type=style&index=0&id=0ccdb3b0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccdb3b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
